define(
  'Header.EntryPoint',
  [
    'jQuery'
  ],
  function (
    jQuery
  ) {
    'use strict';

    function handleSiteSearchToggle(siteSearchButton, siteSearchButtonClose, siteSearchContainer) {
      if (siteSearchButton.data('events-attached')) {
        return;
      }
      siteSearchButton.data('events-attached', true);

      siteSearchButtonClose.on('click', function (event) {
        event.stopPropagation();
        closeSearchContainer(siteSearchContainer);
      });

      siteSearchButton.on('click', function (event) {
        event.stopPropagation();
        if (siteSearchContainer.css('display') === 'none') {
          siteSearchContainer.css('display', 'block');
          setTimeout(function () {
            siteSearchContainer.css('top', '0');
          }, 0);
          jQuery('.itemssearcher-input').focus();
        } else {
          closeSearchContainer(siteSearchContainer);
        }
      });

      jQuery(document).on('click', function (event) {
        if (
          !siteSearchContainer.is(event.target) &&
        siteSearchContainer.has(event.target).length === 0 &&
        !siteSearchButton.is(event.target)
        ) {
          closeSearchContainer(siteSearchContainer);
        }
      });
    }

    function closeSearchContainer(siteSearchContainer) {
      siteSearchContainer.css('top', '-100px');
      setTimeout(function () {
        siteSearchContainer.css('display', 'none');
      }, 300);
    }

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var themeHelpers = environment.getConfig('themeHelpers');
        var headerConfiguration = themeHelpers && themeHelpers.header;

        if (layout && environment) {
          if (headerConfiguration && headerConfiguration.headerLayouts) {
            layout.addToViewContextDefinition('Header.View', 'headerLayout', 'string', function () {
              return headerConfiguration.headerLayouts;
            });
            layout.addToViewContextDefinition('Header.Profile.View', 'headerLayout', 'string', function () {
              return headerConfiguration.headerLayouts;
            });
          }
        }

        layout.on('afterShowContent', function () {
          var siteSearchButton = jQuery('#header-menu-search-button');
          var siteSearchButtonClose = jQuery('#site-search-new-close');
          var siteSearchContainer = jQuery('#site-search-new');
          handleSiteSearchToggle(siteSearchButton, siteSearchButtonClose, siteSearchContainer);
        });
      }
    };
  });
